import { PartLinkTypes } from '~/app/data/statuses/issue';
import {
  EntityStoreKey,
  getEntityStoreKey,
  isEntityEditable,
} from '~/app/common/lineItems/helper';
import { Part } from '~/types';

export type PartStoreKey = EntityStoreKey;

export const getPartStoreKey = (type: PartLinkTypes): PartStoreKey =>
  getEntityStoreKey(type);

export const isPartsEditable = (
  type: PartLinkTypes,
  status: string | number | undefined
): boolean => isEntityEditable(type, status);

const normalizePart = (part: Part) => ({
  id: part.id?.toString().trim(),
  article_no: part.article_no ?? '',
  article_name: part.article_name ?? '',
  price_per_unit: Number(part.price_per_unit) || 0,
  quantity: Number(part.quantity) || 0,
  type: part.type,
  workOrderPartId: part.workOrderPartId?.toString().trim() ?? '',
  customerDiscount: part.customerDiscount ?? 0,
});

const partKey = (part: Part) => part.id?.toString().trim() ?? '';

/** Compare draft vs last-saved list, ignoring `added` and excluding `deleted` draft rows. */
export const isTempPartsDirty = (
  tempParts: Part[],
  parts: Part[]
): boolean => {
  const current = tempParts
    .filter(m => !m.deleted)
    .map(normalizePart)
    .sort((a, b) => a.id.localeCompare(b.id));

  const saved = parts
    .map(normalizePart)
    .sort((a, b) => a.id.localeCompare(b.id));

  if (current.length !== saved.length) {
    return true;
  }

  return current.some((item, index) => {
    const other = saved[index];
    return (
      item.id !== other.id ||
      item.article_no !== other.article_no ||
      item.article_name !== other.article_name ||
      item.price_per_unit !== other.price_per_unit ||
      item.quantity !== other.quantity ||
      item.type !== other.type ||
      item.workOrderPartId !== other.workOrderPartId ||
      item.customerDiscount !== other.customerDiscount
    );
  });
};

export const isPartInTemp = (
  part: Part,
  tempParts: Part[]
): boolean => {
  const id = partKey(part);
  const storageId = part.workOrderPartId?.toString().trim();

  return tempParts.some(tm => {
    if (tm.deleted) {
      return false;
    }
    if (tm.id?.toString().trim() === id) {
      return true;
    }
    if (storageId && tm.workOrderPartId?.toString().trim() === storageId) {
      return true;
    }
    return false;
  });
};
